// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── Complete Org Creation ───────────────────────────────────────────────── */

.ecr-complete-org__form {
  display: flex;
  flex-direction: column;
  gap: 20px;
  max-width: 760px;
}

/* Identity banner (org ID + status) */
.ecr-complete-org__identity-banner {
  display: flex;
  align-items: center;
  gap: 32px;
  background: #1a1a1a;
  border-radius: 10px;
  padding: 14px 20px;
  margin-bottom: 4px;
}

.ecr-complete-org__identity-item {
  display: flex;
  flex-direction: column;
  gap: 3px;
}

.ecr-complete-org__identity-label {
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.6px;
  color: #6b7280;
}

.ecr-complete-org__identity-value {
  font-family: "SFMono-Regular", Consolas, "Liberation Mono", Menlo, monospace;
  font-size: 12px;
  color: #d1d5db;
  background: #2d2d2d;
  padding: 2px 8px;
  border-radius: 5px;
  border: 1px solid #404040;
}

.ecr-complete-org__identity-badge {
  font-size: 11px;
  font-weight: 700;
  color: #fbbf24;
  background: #2d2000;
  border: 1px solid #7a5700;
  padding: 2px 10px;
  border-radius: 20px;
  width: fit-content;
}

/* Card sections */
.ecr-complete-org__card {
  background: #fff;
  border: 1px solid #e5e7eb;
  border-left: 3px solid #86BC25;
  border-radius: 10px;
  padding: 24px 28px;
}

.ecr-complete-org__section-head {
  margin-bottom: 20px;
}

.ecr-complete-org__section-title {
  font-size: 11px;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.6px;
  color: #86BC25;
  margin: 0 0 14px;
}

.ecr-complete-org__section-sub {
  font-size: 12px;
  color: #9ca3af;
  margin: 0;
  text-transform: none;
  letter-spacing: 0;
}

/* Field grid */
.ecr-complete-org__fields {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

/* Select helper error */
.ecr-complete-org__select-error {
  font-size: 11px;
  color: #d32f2f;
  margin: 4px 14px 0;
}

/* Toggle rows */
.ecr-complete-org__toggles {
  display: flex;
  flex-direction: column;
  gap: 0;
}

.ecr-complete-org__toggle-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 0;
}

.ecr-complete-org__toggle-text {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.ecr-complete-org__toggle-label {
  font-size: 13px;
  font-weight: 600;
  color: #111827;
}

.ecr-complete-org__toggle-desc {
  font-size: 11px;
  color: #9ca3af;
  max-width: 520px;
}

/* Actions bar */
.ecr-complete-org__actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 4px;
  padding-bottom: 32px;
}

/* Success state */
.ecr-complete-org__success {
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  padding: 60px 40px;
  text-align: center;
  max-width: 540px;
}

.ecr-complete-org__success-title {
  font-size: 22px;
  font-weight: 800;
  color: #111827;
  margin: 12px 0 8px;
}

.ecr-complete-org__success-sub {
  font-size: 14px;
  color: #6b7280;
  margin: 0 0 28px;
}

.ecr-complete-org__success-actions {
  display: flex;
  gap: 12px;
}

/* ── Chip array input ────────────────────────────────────────────────────── */

.ecr-chip-input {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.ecr-chip-input__label {
  font-size: 12px;
  font-weight: 600;
  color: #374151;
  margin: 0;
}

.ecr-chip-input__required {
  color: #d32f2f;
}

.ecr-chip-input__field {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
  min-height: 40px;
  padding: 6px 10px;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  cursor: text;
  background: #fff;
  transition: border-color 0.15s, box-shadow 0.15s;
}

.ecr-chip-input__field:focus-within {
  border-color: #86BC25;
  box-shadow: 0 0 0 2px rgba(0, 166, 81, 0.15);
}

.ecr-chip-input--error .ecr-chip-input__field {
  border-color: #d32f2f;
}

.ecr-chip-input__text {
  flex: 1 1;
  min-width: 140px;
  border: none;
  outline: none;
  font-size: 13px;
  color: #111827;
  background: transparent;
  font-family: inherit;
  padding: 2px 0;
}

.ecr-chip-input__error {
  font-size: 11px;
  color: #d32f2f;
  margin: 0;
}

.ecr-chip-input__hint {
  font-size: 11px;
  color: #9ca3af;
  margin: 0;
}

.ecr-chip-input__hint kbd {
  font-family: "SFMono-Regular", Consolas, monospace;
  font-size: 10px;
  background: #f3f4f6;
  border: 1px solid #d1d5db;
  border-radius: 3px;
  padding: 1px 4px;
  color: #374151;
}
`, "",{"version":3,"sources":["webpack://./src/pages/ecrOps/EcrOpsCompleteOrg.css"],"names":[],"mappings":"AAAA,+EAA+E;;AAE/E;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;;AAEA,sCAAsC;AACtC;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,4EAA4E;EAC5E,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,kBAAkB;AAClB;EACE,gBAAgB;EAChB,yBAAyB;EACzB,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;EACT,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,wBAAwB;AACxB;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,sBAAsB;EACtB,MAAM;AACR;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA,+EAA+E;;AAE/E;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,gDAAgD;AAClD;;AAEA;EACE,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,eAAe;EACf,cAAc;EACd,uBAAuB;EACvB,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;AACX;;AAEA;EACE,kDAAkD;EAClD,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB","sourcesContent":["/* ── Complete Org Creation ───────────────────────────────────────────────── */\n\n.ecr-complete-org__form {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  max-width: 760px;\n}\n\n/* Identity banner (org ID + status) */\n.ecr-complete-org__identity-banner {\n  display: flex;\n  align-items: center;\n  gap: 32px;\n  background: #1a1a1a;\n  border-radius: 10px;\n  padding: 14px 20px;\n  margin-bottom: 4px;\n}\n\n.ecr-complete-org__identity-item {\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n}\n\n.ecr-complete-org__identity-label {\n  font-size: 10px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.6px;\n  color: #6b7280;\n}\n\n.ecr-complete-org__identity-value {\n  font-family: \"SFMono-Regular\", Consolas, \"Liberation Mono\", Menlo, monospace;\n  font-size: 12px;\n  color: #d1d5db;\n  background: #2d2d2d;\n  padding: 2px 8px;\n  border-radius: 5px;\n  border: 1px solid #404040;\n}\n\n.ecr-complete-org__identity-badge {\n  font-size: 11px;\n  font-weight: 700;\n  color: #fbbf24;\n  background: #2d2000;\n  border: 1px solid #7a5700;\n  padding: 2px 10px;\n  border-radius: 20px;\n  width: fit-content;\n}\n\n/* Card sections */\n.ecr-complete-org__card {\n  background: #fff;\n  border: 1px solid #e5e7eb;\n  border-left: 3px solid #86BC25;\n  border-radius: 10px;\n  padding: 24px 28px;\n}\n\n.ecr-complete-org__section-head {\n  margin-bottom: 20px;\n}\n\n.ecr-complete-org__section-title {\n  font-size: 11px;\n  font-weight: 800;\n  text-transform: uppercase;\n  letter-spacing: 0.6px;\n  color: #86BC25;\n  margin: 0 0 14px;\n}\n\n.ecr-complete-org__section-sub {\n  font-size: 12px;\n  color: #9ca3af;\n  margin: 0;\n  text-transform: none;\n  letter-spacing: 0;\n}\n\n/* Field grid */\n.ecr-complete-org__fields {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n/* Select helper error */\n.ecr-complete-org__select-error {\n  font-size: 11px;\n  color: #d32f2f;\n  margin: 4px 14px 0;\n}\n\n/* Toggle rows */\n.ecr-complete-org__toggles {\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n}\n\n.ecr-complete-org__toggle-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 14px 0;\n}\n\n.ecr-complete-org__toggle-text {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.ecr-complete-org__toggle-label {\n  font-size: 13px;\n  font-weight: 600;\n  color: #111827;\n}\n\n.ecr-complete-org__toggle-desc {\n  font-size: 11px;\n  color: #9ca3af;\n  max-width: 520px;\n}\n\n/* Actions bar */\n.ecr-complete-org__actions {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding-top: 4px;\n  padding-bottom: 32px;\n}\n\n/* Success state */\n.ecr-complete-org__success {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  background: #fff;\n  border: 1px solid #e5e7eb;\n  border-radius: 10px;\n  padding: 60px 40px;\n  text-align: center;\n  max-width: 540px;\n}\n\n.ecr-complete-org__success-title {\n  font-size: 22px;\n  font-weight: 800;\n  color: #111827;\n  margin: 12px 0 8px;\n}\n\n.ecr-complete-org__success-sub {\n  font-size: 14px;\n  color: #6b7280;\n  margin: 0 0 28px;\n}\n\n.ecr-complete-org__success-actions {\n  display: flex;\n  gap: 12px;\n}\n\n/* ── Chip array input ────────────────────────────────────────────────────── */\n\n.ecr-chip-input {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.ecr-chip-input__label {\n  font-size: 12px;\n  font-weight: 600;\n  color: #374151;\n  margin: 0;\n}\n\n.ecr-chip-input__required {\n  color: #d32f2f;\n}\n\n.ecr-chip-input__field {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 6px;\n  min-height: 40px;\n  padding: 6px 10px;\n  border: 1px solid #d1d5db;\n  border-radius: 8px;\n  cursor: text;\n  background: #fff;\n  transition: border-color 0.15s, box-shadow 0.15s;\n}\n\n.ecr-chip-input__field:focus-within {\n  border-color: #86BC25;\n  box-shadow: 0 0 0 2px rgba(0, 166, 81, 0.15);\n}\n\n.ecr-chip-input--error .ecr-chip-input__field {\n  border-color: #d32f2f;\n}\n\n.ecr-chip-input__text {\n  flex: 1;\n  min-width: 140px;\n  border: none;\n  outline: none;\n  font-size: 13px;\n  color: #111827;\n  background: transparent;\n  font-family: inherit;\n  padding: 2px 0;\n}\n\n.ecr-chip-input__error {\n  font-size: 11px;\n  color: #d32f2f;\n  margin: 0;\n}\n\n.ecr-chip-input__hint {\n  font-size: 11px;\n  color: #9ca3af;\n  margin: 0;\n}\n\n.ecr-chip-input__hint kbd {\n  font-family: \"SFMono-Regular\", Consolas, monospace;\n  font-size: 10px;\n  background: #f3f4f6;\n  border: 1px solid #d1d5db;\n  border-radius: 3px;\n  padding: 1px 4px;\n  color: #374151;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
